// extracted by mini-css-extract-plugin
module.exports = {"infoBarSection":"InfoBar_infoBarSection__3hkI8","sincronizarContainer":"InfoBar_sincronizarContainer__3Y_2D"};